import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import { useState } from 'react';
import CropperImage from './cropper/CropperImage';

export const UploadPhoto = ({ handleUploadImage }) => {
  const inputRef = useRef();

  const [image2Crop, setImage2Crop] = useState(null);

  const handleChange = e => {
    const file = e.target.files[0];
    inputRef.current.value = '';
    const objectUrl = URL.createObjectURL(file);

    setImage2Crop(objectUrl);
  };

  const handleCropEnd = croppedImage => {
    setImage2Crop(null);
    handleUploadImage(croppedImage.file);
  };

  return (
    <label className="upload-avatar d-flex flex-column" htmlFor="upload-image">
      <FontAwesomeIcon icon={['fas', 'camera']} size="2x" />

      <span className="fs-1 fw-bold text-center w-100">Actualizar imagen</span>

      <input
        id="upload-image"
        type="file"
        className="d-none"
        onChange={handleChange}
        ref={inputRef}
        accept="image/*"
      />

      <CropperImage
        image={image2Crop}
        open={!!image2Crop}
        setOpen={setImage2Crop}
        onCropEnd={handleCropEnd}
        aspectRatio={1}
      />
    </label>
  );
};

UploadPhoto.propTypes = {
  handleUploadImage: PropTypes.func
};
